import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ConstantsFordProtect } from '../../models/constants/constants-ford-protect';
import { StatusChassi } from '../../models/enum/status-chassi';
import { VinValidate } from '../../models/vin-validate/vin-validate';
import { MessageExceptionService } from '../../services/message-exception/message-exception.service';
import { VinValidateService } from '../../services/vin-validate-service/vin-validate-service.service';

@Component({
    selector: 'app-direct-sale',
    templateUrl: './direct-sale.component.html',
    standalone: false
})
export class DirectSaleComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);

	chassis: string = "";
	vinValidateList: VinValidate[] = [];
	
	constructor(private vinValidateService: VinValidateService,
		private translateService: TranslateService,
		private messageService: MessageService,
		private router: Router,
		private messageExceptionService: MessageExceptionService) {
	}

	ngOnInit() {
		this.vinValidateList = this.vinValidateService.getAllVinValidateList();
	}

	buttonAddChassis() {
		this.searchChassiValidation();
	}

	buttonRemoveChassiList(vinValidate: VinValidate) {
		this.vinValidateList.forEach((element, index)=>{
			if(element.vin === vinValidate.vin) {
				this.vinValidateList.splice(index, 1);
			}			
		});
	}

	buttonNextWindow() {
		if(this.vinValidateList.length > 0) {
			
			let isvalid = true;

			this.vinValidateList.forEach(vinValidate => {
				if(vinValidate.validated === StatusChassi.invalid) {
					isvalid = false; 				
				}
			});

			if(isvalid) {
				this.vinValidateService.setAllVinValidateList(this.vinValidateList);
				this.router.navigate(['plan-selection']);
			} else {
				this.messageService.add({severity:'error', summary: 'Error', detail: 'Remover os chassi com status inválido.'});
			}

		} else {
			this.messageService.add({severity:'error', summary: 'Error', detail: 'Adicionar chassi.'});
		}
	}

	buttonClean() {
		this.chassis = "";
		this.vinValidateList = [];
		this.vinValidateService.getAllVinValidateListClean();
	}

	breakTextByChassi(): string[] {
		let chassiList: string[] = this.chassis.trim().split('\n');		
		chassiList = chassiList.filter((element, i) => i === chassiList.indexOf(element)) //remove duplicidade
		return chassiList;
	}

	searchChassiValidation() {
		this.breakTextByChassi().forEach(chassi => {
			const isDuplicated = this.isDuplicate(chassi);

			if(isDuplicated === false && chassi !== '') {
				this.searchChassiSaveAndVector(chassi);
			}
		});		
	}

	searchChassiSaveAndVector(chassi: string) {

		const country: string = ConstantsFordProtect.BRA;

		this.vinValidateService.getVinValidate(country, chassi, ConstantsFordProtect.PT_BR)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((response: VinValidate) => {				
				const vinValidate: VinValidate = this.vinValidate(response);
				this.vinValidateList.push(vinValidate);
				
			}, (err) => {
				this.messageExceptionService.getMessageException(err.status, 'Sem acesso, por gentileza, fecha a página e faça o login novamente!');
			});
	}

	isDuplicate(chassi: string): boolean {
		let isValide = false;
		
		this.vinValidateList.forEach(vinValidate => {		
			if(chassi.trim() === vinValidate.vin.trim()) {
				isValide = true;
			}
		});

		return isValide;
	}

	vinValidate(vinValidate: VinValidate): VinValidate {
		
		if (vinValidate.errorMessage !== null && vinValidate.errorMessage.trim().toUpperCase() === 'VIN.ERROR.SAVE_VECTOR') {
			vinValidate.validated = StatusChassi.invalid;
		} else {
			vinValidate.validated = StatusChassi.valid;
		}
		
		return vinValidate;
	}
}
